import React, { useMemo } from "react";

import { css } from "@emotion/react";

interface CloseButtonProps {
  setIsVisible: () => void;
}

export const CloseButton = ({ setIsVisible }: CloseButtonProps) => {
  const containerCss = useMemo(
    () => css`
      width: 25px;
    `,
    []
  );
  const closeButtonCss = useMemo(
    () => css`
      position: absolute;
      left: calc(100% - 28px);
      top: 10px;
      &:hover,
      &:focus {
        cursor: pointer;
      }
    `,
    []
  );

  return (
    <div css={containerCss} className={"ig-message-box-close"}>
      <svg
        focusable="false"
        aria-hidden="true"
        viewBox="0 0 25 25"
        data-testid="CloseIcon"
        height="18px"
        stroke="#CBDCD8"
        fill="#CBDCD8"
        css={closeButtonCss}
        onClick={() => setIsVisible()}
      >
        <path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
      </svg>
    </div>
  );
};
